import {isAxiosError, throwException} from '@/utils/errors';
import {
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
    CancelToken
} from 'axios';
import {User} from '@/interfaces/user';
import {IMeClient} from '@/services/IMeClient';
import apiAxiosClient from '@/utils/axios';

export class MeClient implements IMeClient {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
        undefined;
    private instance: AxiosInstance;
    private baseUrl: string;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : apiAxiosClient;

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    me(cancelToken?: CancelToken | undefined): Promise<User> {
        let url_ = this.baseUrl + '/api/Me';
        url_ = url_.replace(/[?&]$/, '');

        const options_ = <AxiosRequestConfig>{
            method: 'GET',
            url: url_,
            headers: {
                Accept: 'text/plain'
            },
            cancelToken
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processMe(_response);
            });
    }

    protected processMe(response: AxiosResponse): Promise<User> {
        const status = response.status;
        const _headers: any = {};
        if (response.headers && typeof response.headers === 'object') {
            for (const k in response.headers) {
                if (Object.prototype.hasOwnProperty.call(response.headers, k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            const resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve<User>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(
                'An unexpected server error occurred.',
                status,
                _responseText,
                _headers
            );
        }
        return Promise.resolve<User>(<any>null);
    }
}

export const MeService = new MeClient();
export default MeService;
